import React from 'react';
import {Home, Mail, TreePine} from "lucide-react";
import {Link} from 'react-router-dom';
import {ContactLinks} from "../../../v2/components/ContactLinks";

const Footer = () => {

    const contacts = {
        phone: "+380 (68) 613 7593",
        email: "hlushman.site@gmail.com"
    }

    return (
        <footer className="w-full border-t border-[#232733] bg-[#12141a] pb-6 pt-12 text-[#a0a5b5]">
            <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 md:flex-row md:justify-between">
                <div className="max-w-xs">
                    <Link to="/" className="mb-3 inline-block text-2xl font-bold text-emerald-600">
                        Hlushman House
                    </Link>
                    <p className="text-sm leading-relaxed text-[#818898]">
                        Ми поєднали сучасний комфорт та елегантний дизайн із величними панорами Карпат, кришталевим повітрям і тишею, про яку ви так довго мріяли. Це місце, де створюються спогади.
                    </p>
                </div>

                <div className="flex flex-wrap gap-10 md:gap-12">
                    <div className="flex flex-col gap-2 text-sm">
                        <span className="mb-2 font-semibold text-white">Клієнтам</span>
                        <Link to="/sell-house" className="transition-colors hover:text-emerald-600" target={'_blank'}>
                            Продаж Будинка
                        </Link>
                        <Link to="/rent-house/#booking" className="transition-colors hover:text-emerald-600" target={'_blank'}>
                            Оренда Будинку
                        </Link>
                        <Link to="https://www.olx.ua/uk/list/user/oPund/" className="transition-colors hover:text-emerald-600" target={'_blank'}>
                            Дерев'яні вироби
                        </Link>
                    </div>

                    <div className="flex flex-col gap-2 text-sm">
                        <span className="mb-2 font-semibold text-white">Контакти</span>
                        <Link to="/links" className="transition-colors hover:text-emerald-600 flex">
                            <TreePine className={'mx-1'} size={16} /> Дерево посилань
                        </Link>
                        {/*<Link to={"tel:" + contacts.phone} className="transition-colors hover:text-emerald-600">*/}
                        {/*    Тел: {contacts.phone}*/}
                        {/*</Link>*/}
                        <Link to={"mailto:" + contacts.email} className="transition-colors hover:text-emerald-600 flex">
                            <Mail className={'mx-1'} size={16} /> {contacts.email}
                        </Link>

                        <ContactLinks />
                    </div>

                    <div className="flex flex-col gap-2 text-sm">
                        <span className="mb-2 font-semibold text-white">Навігація</span>
                        <Link to="/" className="transition-colors hover:text-emerald-600">
                            Головна
                        </Link>
                        <Link to="/about" className="transition-colors hover:text-emerald-600">
                            Про нас
                        </Link>
                        <Link to="/contacts" className="transition-colors hover:text-emerald-600">
                            Контакти
                        </Link>
                    </div>

                    <div className="flex flex-col gap-2 text-sm">
                        <span className="mb-2 font-semibold text-white">Юридична інформація</span>
                        <Link to="/legal/privacy-policy" className="transition-colors hover:text-emerald-600">
                            Privacy Policy
                        </Link>
                        <Link to="/legal/terms-of-service" className="transition-colors hover:text-emerald-600">
                            Terms of Service
                        </Link>
                        <Link to="/legal/cookies-policy" className="transition-colors hover:text-emerald-600">
                            Cookie Policy
                        </Link>
                    </div>
                </div>
            </div>

            <div className="mx-auto mt-10 max-w-7xl border-t border-[#1e222d] px-6 pt-6 text-center text-xs text-[#61687a]">
                <p>&copy; {new Date().getFullYear()} Hlushman House. Усі права захищені.</p>
            </div>
        </footer>
    );
};

export default Footer;